import React from 'react';
import PropTypes from 'prop-types';
import CopyPasteStore from '@src/stores/CopyPasteStore';

import Label from '../Label';

function SubstoryHeader({
  id,
  active,
  disabled,
  color,
  onClick,
  contextMenuItems,
  title,
  ExpandIcon,
  onDrop,
  onSubstoryRename,
  inputMode,
  setInputMode,
  closeAddSkillDrawer,
  isSmartSkill
}) {
  const dragData = CopyPasteStore.getDragData();

  const labelProps = {
    active,
    disabled,
    color: color.primary,
    onClick,
    contextMenuItems,
    dropActive: dragData && dragData.subStory.id !== id,
    onDrop,
    onRename: onSubstoryRename,
    title,
    ExpandIcon,
    inputMode,
    isSmartSkill,
    closeAddSkillDrawer,
    setInputMode: (isInput) => {
      setInputMode(isInput);
    },
  };

  return (
    <Label {...labelProps}>
      {title}
      <ExpandIcon />
    </Label>
  );
}

SubstoryHeader.propTypes = {
  ExpandIcon: PropTypes.node,
  active: PropTypes.bool,
  color: PropTypes.shape({
    primary: PropTypes.string,
  }),
  contextMenuItems: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onDrop: PropTypes.func,
  onSubstoryRename: PropTypes.func,
  title: PropTypes.string,
};

SubstoryHeader.defaultProps = {
  id: '',
  active: false,
  disabled: false,
  ExpandIcon: null,
  onClick: () => {},
  onDrop: () => {},
  onSubstoryRename: () => {},
  contextMenuItems: [],
  title: '',
  color: {
    primary: '',
  },
};

export default SubstoryHeader;
